export enum ENTITY {
  VIEW = 'view',
  GANTT_CHART = 'gantChart',
  LIST_CONTROL = 'listControl',
  DROP_DOWN_ENTITY = 'dropdownEntity',
}

export const ENTITY_PATH: Record<ENTITY, string> = {
  view: 'VIEWS',
  gantChart: 'GANTT_CHART',
  listControl: 'LIST_CONTROLS',
  dropdownEntity: 'DROP_DOWN_ENTITY',
}

export const enum WINDOW_ENTITY {
  VIEW = 'VIEW',
  FORM = 'FORM',
  GANTT_CHART = 'GANTTCHART',
}

export enum ENTITY_TYPES_REQUEST {
  LIST_CONTROL = 'LIST_CONTROL',
  VIEW = 'DEFAULT',
  DROP_DOWN_ENTITY = 'DROP_DOWN_ENTITY',
  GANTT_CHART = 'GANTT_CHART',
  MENU = 'MENU',
  FORM = 'FORM',
  WINDOW = 'WINDOW',
  CONTEXT_MENU = 'CONTEXT_MENU',
  TOOLTIP = 'TOOLTIP',
  TIME_TABLE = 'TIME_TABLE',
}

export enum DROPDOWN_FILTER_TYPES {
  WINDOW = 'WINDOW',
  LIST = 'LIST',
}

export enum CLICK_EVENT_TYPE {
  EDIT_CLICK = 'EDIT_CLICK',
  CREATE_CLICK = 'CREATE_CLICK',
  ROW_CLICK = 'ROW_CLICK',
  CELL_CLICK = 'CELL_CLICK',
}

export const GRID_CELL_MODE = {
  VIEW: 'view',
  EDIT: 'edit',
}

export const CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME =
  'CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID'
